var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLbGlowGold = props => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  viewBox: "0 0 292 334",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "glow",
  opacity: 0.3,
  filter: "url(#filter0_f_0_13)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 146,
  cy: 167,
  rx: 46,
  ry: 67,
  fill: "#FFCD35"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_0_13",
  x: 0,
  y: 0,
  width: 292,
  height: 334,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 36.25,
  result: "effect1_foregroundBlur_0_13"
})))));
export default SvgLbGlowGold;